import { useState } from 'react';
import { shallowEqual } from 'react-redux';
import { Document, Page } from 'react-pdf';

import { Tabs } from '@zillow/constellation';
import { Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';

import SpinnerContainer from '../../SpinnerContainer';
import { StyledPDFDocumentWrapper, StyledTabPanel } from './StyledComponents';

import AppSelectors from '../../../selectors/AppSelectors';
import { useSelector } from '../../../selectors/useSelector';

// @ts-expect-error
import ApplicantSummaryWeb from '../../../images/applicationSample/web/ApplicantSummaryWeb.pdf';
// @ts-expect-error
import BackgroundCheckWeb from '../../../images/applicationSample/web/BackgroundCheckWeb.pdf';
// @ts-expect-error
import CreditReportWeb from '../../../images/applicationSample/web/CreditReportWeb.pdf';

// @ts-expect-error
import ApplicantSummaryMWeb from '../../../images/applicationSample/mweb/ApplicantSummaryMWeb.pdf';
// @ts-expect-error
import CreditReportMWeb from '../../../images/applicationSample/mweb/CreditReportMWeb.pdf';
// @ts-expect-error
import BackgroundCheckMWeb from '../../../images/applicationSample/mweb/BackgroundCheckMWeb.pdf';

const { makeIsScreenMobile } = AppSelectors;

const ApplicationSampleModal = ({ onClose }: { onClose: () => void }) => {
  const isScreenMobile = useSelector((state) => makeIsScreenMobile(state), shallowEqual);

  const [state, setState] = useState({ selected: 'summary-tab' });

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={6}>Application sample</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <>
          <Paragraph css={{ paddingBottom: '400' }}>
            <Icon css={{ color: 'icon.accent.blue.strong' }}>
              <IconInfoFilled />
            </Icon>{' '}
            These documents are for viewing purposes only.
          </Paragraph>
          <Tabs appearance="file" selected={state.selected} onSelected={(selected: string) => setState({ selected })}>
            <Tabs.List aria-label="sample-application-files">
              <Tabs.Tab id="summary-tab">Applicant Summary</Tabs.Tab>
              <Tabs.Tab id="credit-tab">Credit Report</Tabs.Tab>
              <Tabs.Tab id="background-tab">Background Check</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panels>
              <StyledTabPanel aria-labelledby="summary-tab">
                <StyledPDFDocumentWrapper>
                  <Document
                    file={isScreenMobile ? ApplicantSummaryMWeb : ApplicantSummaryWeb}
                    loading={<SpinnerContainer height="90vh" />}
                    options={{ isEvalSupported: false }}
                  >
                    <Page pageNumber={1} renderTextLayer={false} />
                  </Document>
                </StyledPDFDocumentWrapper>
              </StyledTabPanel>
              <StyledTabPanel aria-labelledby="credit-tab">
                <StyledPDFDocumentWrapper>
                  <Document
                    file={isScreenMobile ? CreditReportMWeb : CreditReportWeb}
                    loading={<SpinnerContainer height="90vh" />}
                    options={{ isEvalSupported: false }}
                  >
                    <Page pageNumber={1} renderTextLayer={false} />
                  </Document>
                </StyledPDFDocumentWrapper>
              </StyledTabPanel>
              <StyledTabPanel aria-labelledby="background-tab">
                <StyledPDFDocumentWrapper>
                  <Document
                    file={isScreenMobile ? BackgroundCheckMWeb : BackgroundCheckWeb}
                    loading={<SpinnerContainer height="90vh" size="md" />}
                    options={{ isEvalSupported: false }}
                  >
                    <Page pageNumber={1} renderTextLayer={false} />
                  </Document>
                </StyledPDFDocumentWrapper>
              </StyledTabPanel>
            </Tabs.Panels>
          </Tabs>
        </>
      }
    />
  );
};

export default ApplicationSampleModal;
